export default {
  'zh': '中文',
  'ja': '日语',
  'kr': '韩语',
  'en': '英语',
  'ru' : '俄语',
  'vi' : '越南语',
  // 'th' : '泰语',
  // 'tr' : '土耳其语'
};
